import wixWindow from 'wix-window';
const viewMode = wixWindow.viewMode;

$w.onReady(async function () {
	const initialData = await $w('#albumsGallery').onReady();
	refreshAlbumData(initialData);
	if (viewMode === "Preview") {
		$w('#albumsGallery').onRefreshHappened((data) => {
			refreshAlbumData(data);
		});
		$w('#albumsGallery').reportPageLoaded();
	}
});

function refreshAlbumData({albumData, sets}) {
	try {
		if (!albumData || !sets) {
			return;
		}
		$w('#imageX1').src = albumData.coverUrl;
		$w('#textAlbumNameMobile').text = albumData.albumName;
		$w('#dateMobile').text = albumData.albumDate;
		$w('#photographerName').label = albumData.brand.name;
		$w('#viewAlbumButton').label = albumData.welcome;
		$w('#viewAlbumButton').link = albumData.coverLink;
		if (albumData.logoUrl) {
			$w('#logoNativGallery').show();
			$w('#logoNativGallery').items = albumData.logoNativePGItem;
			// $w('#logoGallery').show();
			// $w('#logoGallery').items = albumData.logoItems;
		} else {
			$w('#logoNativGallery').hide();
			// $w('#logoGallery').hide();
		}
		if (viewMode !== 'Preview') {
			$w('#photographerName').link = albumData.motherSiteUrl;
		}
	} catch (e) {
		console.error("Error_On_Page", e);
	}
}